import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateFuelCellPhase',
})
export class TranslateFuelCellPhasePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (value && this.customTranslationsService.FUEL_CELL_OPERATING_PHASES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.FUEL_CELL_OPERATING_PHASES[value] ?? value
      );
    }

    return value;
  }
}
